import React from 'react'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import ConnectedBankDetailsSection from '../../View/BankDetailsSection'

const BankDetailsSection = ({ ambassador, logsParams }) => {
  return (
    <AmbassadorSection>
      <ConnectedBankDetailsSection
        ambassadorId={ambassador.id}
        paymentDetails={ambassador.paymentDetails}
        withholdPay={ambassador.withholdPay}
        fixedPriceMissions={ambassador.fixedPriceMissions}
        logsParams={logsParams}
      />
    </AmbassadorSection>
  )
}

export default BankDetailsSection
